enum adminRoutes {
  PRE_ORDERS = "preCommandes",
  OBJECTIVES = "objectifs",
  PRE_ORDER_DETAILS = "preCommande/:id",
  REPRESENTANT_SITES = "administration/sites-representants",
}

export default adminRoutes;
